exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Sorry */\n.style-override-in-style-block-1 {\n  border-radius: 9999px !important;\n  height: 2.5rem !important;\n}\n.style-override-in-style-block-2 {\n  background: #fff !important;\n}\n", ""]);

// exports
